export class BondsmanIdentifier {
    licenseNumber: string;
    stateLicenseId: number

    constructor(licenseNumber: string) {
       this.licenseNumber = licenseNumber;
    }

    setStateLicenseId(stateLicenseId: number) {
       this.stateLicenseId = stateLicenseId;
    }

    equals(bondsmanIdentifier: BondsmanIdentifier): boolean {
       if (bondsmanIdentifier === null || bondsmanIdentifier === undefined ) {
            return false;
       }

       return (this.licenseNumber === bondsmanIdentifier.licenseNumber);
    }
}

export enum LicenseType {
    BONDSMAN = 'BONDSMAN',
    RUNNER = 'RUNNER',
    AGENT = 'AGENT'
  }



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/bondsman-identifier.ts